import React from 'react';
import { Button, Drawer, Typography } from 'antd';
import TruNorthDashboard from './TruNorthDashboard/TruNorthDashboard';
import Cb360Dashboard from './Cb360Dashboard/Cb360Dashboard';
import CwbDashboard from './CwbDashboard/CwbDashboard';
import DCADashboard from './DCADashboard/DCADashboard';
import {
  CBOKeyAssetsDisplayName as LABELS,
  TruNorthFeature,
  CBOKeyAssets,
  CBOKeyAssetsDisplayName,
} from '../../containers/CBOSidebar/CBOSidebarConstants';
import './KeyAssets.less';
import CMSDashboard from './CMSDashboard/CMSDashboard';
import OperateEdgeDashboard from './OperateEdgeDashboard/OperateEdgeDashboard';
import InnowakeDiscoveryDashboard from './InnowakeDiscoveryDashboard/InnowakeDiscoveryDashboard';
import ApiVaultDashboard from './ApiVaultDashboard/ApiVaultDashboard';
import DigitalTesterDashboard from './DigitalTesterDashboard/DigitalTesterDashboard';
import { IProduct } from '../../libs/models/cbo/EngagementModels';
import CBOTruNorthDecomposeDashboard from './CBOTruNorthDecomposeDashboard/CBOTruNorthDecomposeDashboard';
import CATEDashboard from './CATEDashboard/CATEDashboard';
import DRECTDashboard from './DRECTDashboard/DRECTDashboard';
import SASModernizerDashboard from './SASModernizerDashboard/SASModernizerDashboard';
import SmartDQDashboard from './SmartDQDashboard/SmartDQDashboard';
import IBGDashboard from './IBGDashboard/IBGDashboard';
import OperateOptimizerDashboard from './OperateOptimizerDashboard/OperateOptimizerDashboard';
import { useAppSelector, IApplicationState } from '../../libs/store/reducers';
import AIPDashboard from './AIPDashboard/AIPDashboard';

interface IKeyAssetsProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  url?: string;
  assetName?: string;
  assetUrl?: string;
  selectedAssetConfig?: IProduct;
  isEngagement?: boolean;
  selectedEnagagementName?: string;
  selectedEnagagementId?: string;
}

const KeyAssets = ({
  visible,
  onClose,
  title,
  assetName,
  assetUrl,
  selectedAssetConfig,
  isEngagement,
  selectedEnagagementName,
  selectedEnagagementId,
}: IKeyAssetsProps) => {
  const { selectedClientName } = useAppSelector((state: IApplicationState) => ({
    selectedClientName: state.cboViewSummary.selectedClientName,
  }));

  return (
    <Drawer
      className="cbo-drawer"
      title={title}
      placement="right"
      width="100%"
      onClose={onClose}
      styles={{ body: { padding: 0 } }}
      open={visible}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/config-icons/cbo-config-eng/close-icon.png`}
          alt={'Close Drawer'}
        />
      }
    >
      {assetName == CBOKeyAssets.cboTruNorthModernizationCentral && (
        <TruNorthDashboard
          url={assetUrl}
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboCB360Asset && (
        <Cb360Dashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboCWBAsset && (
        <CwbDashboard
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboDCAAsset && (
        <DCADashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title == LABELS.cboTruNorthDecomposeModernization ||
        title === LABELS.cboTruNorthDecomposeDecomposition) && (
        <CBOTruNorthDecomposeDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title === CBOKeyAssets.cate || assetName === CBOKeyAssets.cate) && (
        <CATEDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title === CBOKeyAssets.operateOptimizer || assetName === CBOKeyAssets.operateOptimizer) && (
        <OperateOptimizerDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title === CBOKeyAssets.reportReverseEngineering ||
        assetName === CBOKeyAssets.reportReverseEngineering) && (
        <DRECTDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title === CBOKeyAssets.sasModernizer || assetName === CBOKeyAssets.sasModernizer) && (
        <SASModernizerDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title === CBOKeyAssets.smartDQ ||
        assetName === CBOKeyAssets.smartDQ ||
        title === CBOKeyAssets.smartDataQuality ||
        assetName === CBOKeyAssets.smartDataQuality) && (
        <SmartDQDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {(title === CBOKeyAssets.intelligentBusinessGlossary ||
        assetName === CBOKeyAssets.intelligentBusinessGlossary) && (
        <IBGDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboCOFTAAsset && <CwbDashboard />}
      {title == LABELS.cms && (
        <CMSDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.ascendForOperate && (
        <OperateEdgeDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {assetName == CBOKeyAssets.truNorthCodeDiscovery && (
        <InnowakeDiscoveryDashboard
          selectedAssetConfig={selectedAssetConfig}
          url={assetUrl}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboApiVault && (
        <ApiVaultDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboDCPAsset && (
        <DCADashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.cboDigitalTester && (
        <DigitalTesterDashboard
          selectedAssetConfig={selectedAssetConfig}
          isEngagement={isEngagement}
          selectedEnagagementName={selectedEnagagementName}
          selectedEnagagementId={selectedEnagagementId}
          selectedClientName={selectedClientName}
        />
      )}
      {title == LABELS.ascendPMO && (
        <AIPDashboard
          selectedClientName={selectedClientName}
          selectedAssetConfig={selectedAssetConfig}
        />
      )}
    </Drawer>
  );
};

export default KeyAssets;
